import { z } from 'zod';

export const DescendantsByUrnsPostRequestZod = z.object({
  entityUrns: z.array(z.string()),
  environment: z.string(),
});
